/**
 * @generated SignedSource<<f5b55b1d53f20a9a58439a40d53378eb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MissionControlHeader_viewer$data = {
  readonly email: string | null;
  readonly actualPersonId: string | null;
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly company: {
    readonly id: string;
    readonly name: string | null;
  } | null;
  readonly " $fragmentType": "MissionControlHeader_viewer";
};
export type MissionControlHeader_viewer$key = {
  readonly " $data"?: MissionControlHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MissionControlHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MissionControlHeader_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "1305ab1a41e40466e80b4f642a8abf20";

export default node;
